import Swal from 'sweetalert2';

export const showWarningConfirmation = (onConfirm) => {
  Swal.fire({
    title: 'Are you sure?',
    text: 'If there is an invoice.Do you want to close?',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Yes, continue',
    cancelButtonText: 'No, cancel',
    confirmButtonColor: 'rgb(24 46 89)',
    reverseButtons: false,
    allowOutsideClick: false, 
  }).then((result) => {
    if (result.isConfirmed) {
      onConfirm();
    }
    
  });
};
export const showSubmitConfirmation = (onConfirm) => {
    Swal.fire({
      title: 'Confirm Submission',
      text: 'Are you sure to submit ?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Submit',
      cancelButtonText: 'Cancel',
      confirmButtonColor: 'rgb(24 46 89)',
      reverseButtons: false,
      allowOutsideClick: false,
    }).then((result) => {
      if (result.isConfirmed) {
        onConfirm();
      }
    });
  };
  